import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Fourtinseaterurbania() {



    const cardData =
    {
        keyword: '14 Seater Urbania on Rent in Pune',
        heading: 'Urbania on rent in pune: 14 Seater Urbania on Rent in Pune ',
        headingDescription: 'Urbania On Rent in Pune offers comfortable and reliable 14 Seater Urbania on Rent in Pune for corporate travel, family trips, weddings, tours, and group transportation across the city. Our well-maintained Force Urbania 14-seater vehicles are spacious, air-conditioned, and designed for smooth journeys, making them ideal for airport transfers, corporate events, sightseeing, and outstation travel from Pune. With experienced chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from prime locations including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Viman Nagar, Pimpri Chinchwad, and Pune Airport, we ensure a safe and hassle-free travel experience. Backed by 24/7 booking support, punctual service, and competitive pricing, Urbania On Rent in Pune stands out as the trusted choice for premium 14 seater Urbania hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


        "topPlaces": [
            {
                "title": "Shaniwar Wada",
                "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical landmark and a symbol of Maratha power. Once the administrative seat of Bajirao I, the fort complex featured grand halls, fountains, and courtyards. Although a major fire destroyed much of the structure, the massive stone walls, gates like the Delhi Darwaza, and remaining ruins still reflect its former grandeur. The evening light-and-sound show vividly narrates Maratha history, making it a must-visit heritage attraction."
            },
            {
                "title": "Aga Khan Palace",
                "description": "Aga Khan Palace is a significant monument linked to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum displaying photographs, letters, and personal belongings of Gandhi. Surrounded by lush gardens and Italian-style arches, the palace offers a peaceful yet historically powerful experience."
            },
            {
                "title": "Sinhagad Fort",
                "description": "Sinhagad Fort stands atop a rugged hill in the Sahyadri range and is renowned for the heroic sacrifice of Tanaji Malusare in 1670. The fort offers breathtaking panoramic views of Pune and surrounding valleys. Visitors can trek or drive to explore ancient ramparts, memorials, and gates. Local food stalls serving traditional pithla-bhakri add to the authentic experience, making it a favorite spot for history lovers and adventure seekers."
            },
            {
                "title": "Dagdusheth Halwai Ganpati Temple",
                "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The beautifully adorned idol, decorated with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of grand celebrations with processions and cultural events. The temple trust is also known for its social and charitable initiatives, making it both a spiritual and cultural landmark."
            },
            {
                "title": "Pataleshwar Cave Temple",
                "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva, carved from a single basalt rock. Despite being located in a busy area, the temple offers a calm and meditative atmosphere. The monolithic pillars, circular Nandi mandap, and ancient carvings showcase early Indian craftsmanship. It is one of Pune’s lesser-known yet spiritually rich heritage sites."
            },
            {
                "title": "Raja Dinkar Kelkar Museum",
                "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar to preserve Indian art and culture. Exhibits include musical instruments, sculptures, lamps, utensils, and traditional household items. The recreated Mastani Mahal is a major highlight. The museum offers a deep insight into India’s cultural diversity and traditional craftsmanship."
            },
            {
                "title": "Parvati Hill and Temple",
                "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic city views after climbing 103 stone steps. The hilltop temple complex dates back to the Peshwa era and is dedicated to Lord Shiva and Goddess Parvati. Smaller temples and a museum enrich the visit. Sunrise and sunset views from the hill are especially popular among locals and tourists."
            },
            {
                "title": "Osho Ashram",
                "description": "Located in Koregaon Park, the Osho International Meditation Resort is a world-famous center for meditation and mindfulness. Spread across landscaped gardens, it offers meditation programs, wellness therapies, and spiritual retreats. Visitors from across the globe come here seeking inner peace, relaxation, and personal transformation, making it an international spiritual destination."
            },
            {
                "title": "Pu La Deshpande Garden",
                "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing streams, arched bridges, manicured lawns, and seasonal flowers. Ideal for morning walks, family outings, and photography, the garden blends Japanese aesthetics with Indian natural beauty, offering a serene green escape."
            },
            {
                "title": "Khadakwasla Dam",
                "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend getaway near Pune. The vast reservoir, cool breeze, and surrounding hills create a refreshing atmosphere, especially during monsoon and evenings. Street vendors selling corn and tea add local charm. It also serves as a gateway to Sinhagad Fort, making it a scenic leisure destination."
            }
        ],



"services": [
{
"name": "14 Seater Urbania on Rent Pune",
"description": "14 Seater Urbania on Rent Pune offers a spacious and comfortable travel solution for medium-sized groups. Ideal for city travel, family outings, corporate use, and events, the service provides well-maintained vehicles with professional chauffeurs, ample legroom, luggage space, and reliable transportation across Pune."
},
{
"name": "14 Seater Urbania Bus Hire Pune",
"description": "14 Seater Urbania Bus Hire Pune delivers dependable group transportation for tours, office trips, and social functions. Clean interiors, experienced drivers, and punctual service ensure safe and comfortable travel for groups across the city and nearby destinations."
},
{
"name": "14 Seater Urbania Rental Pune",
"description": "14 Seater Urbania Rental Pune provides flexible rental options for short-term, full-day, and multi-day travel needs. Suitable for local, outstation, and customized itineraries, the service emphasizes well-maintained vehicles, professional chauffeur support, and consistent service quality."
},
{
"name": "14 Seater Urbania AC Bus Pune",
"description": "14 Seater Urbania AC Bus Pune offers fully air-conditioned Urbania vehicles for a comfortable and premium travel experience. Ideal for corporate trips, family travel, and long-distance journeys, these AC buses ensure cool interiors, smooth rides, and professional chauffeur service."
},
{
"name": "14 Seater Luxury Urbania Pune",
"description": "14 Seater Luxury Urbania Pune provides a premium travel experience with plush seating, stylish interiors, and superior comfort. Perfect for VIP travel, corporate executives, weddings, and luxury group tours, this service combines elegance with professional chauffeur-driven travel."
},
{
"name": "14 Seater Urbania for Corporate Pune",
"description": "14 Seater Urbania for Corporate Pune offers reliable and professional transportation for offices, meetings, conferences, and corporate events. With punctual pickups, trained drivers, and well-maintained vehicles, the service ensures smooth corporate group travel."
},
{
"name": "14 Seater Urbania for Outstation Pune",
"description": "14 Seater Urbania for Outstation Pune provides safe and comfortable long-distance travel with highway-trained chauffeurs and reliable Urbania vehicles. Ideal for weekend trips, business journeys, and tours, the service ensures hassle-free and smooth outstation travel."
},
{
"name": "14 Seater Urbania for Family Trip Pune",
"description": "14 Seater Urbania for Family Trip Pune is designed for comfortable family travel with spacious seating, luggage space, and courteous chauffeurs. Perfect for vacations, religious trips, and leisure outings, this service ensures safe and enjoyable journeys."
},
{
"name": "14 Seater Urbania Wedding Hire Pune",
"description": "14 Seater Urbania Wedding Hire Pune delivers elegant and reliable transportation for weddings, family guests, and event logistics. With professional drivers, clean vehicles, and punctual service, it ensures smooth coordination for pre-wedding and wedding-day travel."
},
{
"name": "14 Seater Urbania Airport Transfer Pune",
"description": "14 Seater Urbania Airport Transfer Pune provides timely and hassle-free airport pickups and drops for group travelers. With ample luggage capacity, experienced chauffeurs, and punctual service, this option is ideal for families, tourists, and corporate travelers."
},
{
"name": "Affordable 14 Seater Urbania Pune",
"description": "Affordable 14 Seater Urbania Pune offers budget-friendly rental solutions without compromising on comfort or safety. Ideal for families, offices, and group travel, the service provides transparent pricing, well-maintained vehicles, and reliable transportation."
},
{
"name": "Best 14 Seater Urbania on Rent Pune",
"description": "Best 14 Seater Urbania on Rent Pune delivers top-rated Urbania rental services known for vehicle quality, professional chauffeurs, and customer satisfaction. Trusted for local, outstation, and event travel, this service ensures comfort, reliability, and timely service."
},
{
"name": "14 Seater Chauffeur Driven Urbania Pune",
"description": "14 Seater Chauffeur Driven Urbania Pune offers stress-free travel with trained, background-verified chauffeurs experienced in city and highway routes. Ideal for corporate, family, and long-distance travel, the service emphasizes safety, punctuality, and professionalism."
},
{
"name": "14 Seater Urbania Group Travel Pune",
"description": "14 Seater Urbania Group Travel Pune provides organized and comfortable transportation for groups traveling together. Suitable for tours, corporate outings, and social gatherings, the service ensures smooth rides, spacious seating, and coordinated group travel."
},
{
"name": "14 Seater Urbania Tour Package Pune",
"description": "14 Seater Urbania Tour Package Pune offers customized tour packages for sightseeing, weekend trips, and outstation travel. With planned itineraries, comfortable vehicles, and professional chauffeurs, the service ensures a hassle-free and memorable group travel experience."
}
],
"tableData": [
["14 Seater Urbania on Rent Pune", "14 Seater Urbania Bus Hire Pune"],
["14 Seater Urbania Rental Pune", "14 Seater Urbania AC Bus Pune"],
["14 Seater Luxury Urbania Pune", "14 Seater Urbania for Corporate Pune"],
["14 Seater Urbania for Outstation Pune", "14 Seater Urbania for Family Trip Pune"],
["14 Seater Urbania Wedding Hire Pune", "14 Seater Urbania Airport Transfer Pune"],
["Affordable 14 Seater Urbania Pune", "Best 14 Seater Urbania on Rent Pune"],
["14 Seater Chauffeur Driven Urbania Pune", "14 Seater Urbania Group Travel Pune"],
["14 Seater Urbania Tour Package Pune", ""]
],








"whychoose": [
    {
        "WhyChooseheading": "Best 14 Seater Urbania on Rent in Pune",
        "WhyChoosedescription": "14 Seater Urbania on Rent in Pune is an ideal choice for comfortable and spacious group travel, suitable for corporate trips, family outings, weddings, and outstation journeys."
    },
    {
        "WhyChooseheading": "Luxury and Spacious Force Urbania Vehicles",
        "WhyChoosedescription": "14 Seater Urbania on Rent in Pune offers premium Force Urbania vehicles with modern interiors, ample legroom, and air-conditioning for a smooth travel experience."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "14 Seater Urbania on Rent in Pune comes with skilled drivers who are familiar with local routes and highways, ensuring safe, timely, and hassle-free travel."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Choose 14 Seater Urbania on Rent in Pune for competitive pricing with no hidden charges, making group travel reliable and budget-friendly."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "14 Seater Urbania on Rent in Pune includes round-the-clock support for bookings, inquiries, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "14 Seater Urbania on Rent in Pune is available for hourly rentals, full-day bookings, corporate travel, wedding transportation, and customized outstation packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All vehicles provided for 14 Seater Urbania on Rent in Pune are regularly serviced and sanitized to ensure a clean, safe, and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "14 Seater Urbania on Rent in Pune guarantees on-time pickups and dependable service, ensuring smooth and stress-free group travel."
    }
]
}

const faqData = [
    {
        question: 'Is 14 Seater Urbania on Rent in Pune available for local and outstation travel?',
        answer: 'Yes, 14 Seater Urbania on Rent in Pune is available for both local city travel and outstation journeys, offering a premium and comfortable travel experience.',
    },
    {
        question: 'How can I book 14 Seater Urbania on Rent in Pune?',
        answer: 'You can easily book 14 Seater Urbania on Rent in Pune through phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose 14 Seater Urbania on Rent in Pune for group travel?',
        answer: '14 Seater Urbania on Rent in Pune offers spacious seating, luxury interiors, ample luggage space, and smooth ride quality, making it ideal for group, family, and corporate travel.',
    },
    {
        question: 'Is 14 Seater Urbania on Rent in Pune suitable for corporate and event travel?',
        answer: 'Yes, 14 Seater Urbania on Rent in Pune is perfect for corporate trips, airport transfers, weddings, events, and business meetings.',
    },
    {
        question: 'Are drivers experienced with 14 Seater Urbania on Rent in Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with 14 Seater Urbania on Rent in Pune?',
        answer: 'Absolutely. 14 Seater Urbania on Rent in Pune allows flexible pickup and drop-off locations across Pune and nearby areas.',
    },
    {
        question: 'Is 14 Seater Urbania on Rent in Pune available 24x7?',
        answer: 'Yes, 14 Seater Urbania on Rent in Pune operates 24x7 to meet your travel needs at any time of the day or night.',
    },
    {
        question: 'Are hygiene and safety standards maintained for 14 Seater Urbania on Rent in Pune?',
        answer: 'Yes, all vehicles are regularly sanitized and maintained, and strict safety protocols are followed for every trip.',
    },
    {
        question: 'What payment options are available for 14 Seater Urbania on Rent in Pune?',
        answer: '14 Seater Urbania on Rent in Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout your journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Ajit Kulkarni',
        feedback: 'We booked 14 Seater Urbania on Rent in Pune for a family event. The vehicle was spacious, clean, and extremely comfortable. Great experience!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Rutuja Deshmukh',
        feedback: '14 Seater Urbania on Rent in Pune provided excellent service for our corporate trip. Professional driver and smooth ride. Highly recommended.',
        rating: 5,
    },
];










































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "14 Seater Urbania on Rent in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/14-seater-urbania-on-rent-pune.jpg",
  "description": "14 Seater Urbania on Rent in Pune offers premium Force Urbania rental services for corporate travel, family trips, weddings, airport transfers, group travel, and outstation tours. Spacious 14 seater AC luxury Urbania buses with professional chauffeur-driven service are available at affordable prices.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1680",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4900",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/14-seater-urbania-on-rent-pune"
  }
};







    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | 14 Seater Urbania on Rent in Pune | Luxury AC Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book 14 Seater Urbania on rent in Pune for corporate travel, family trips, weddings, airport transfers, group tours, and outstation journeys. Luxury AC 14 seater Urbania bus hire with chauffeur-driven service at affordable rates."
  />

  <meta
    name="keywords"
    content="14 Seater Urbania on Rent Pune, 14 Seater Urbania Bus Hire Pune, 14 Seater Urbania Rental Pune, 14 Seater Urbania AC Bus Pune, 14 Seater Luxury Urbania Pune, 14 Seater Urbania for Corporate Pune, 14 Seater Urbania for Outstation Pune, 14 Seater Urbania for Family Trip Pune, 14 Seater Urbania Wedding Hire Pune, 14 Seater Urbania Airport Transfer Pune, Affordable 14 Seater Urbania Pune, Best 14 Seater Urbania on Rent Pune, 14 Seater Chauffeur Driven Urbania Pune, 14 Seater Urbania Group Travel Pune, 14 Seater Urbania Tour Package Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Fourtinseaterurbania;